function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.003,
    height: 40,
    viewBox: "0 0 40.003 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-call",
    d: "M43.338 35.823a33.6 33.6 0 0 0-7.019-4.7c-2.1-1.01-2.874-.989-4.363.083-1.239.9-2.041 1.729-3.468 1.416s-4.238-2.437-6.967-5.155-4.853-5.54-5.155-6.967.531-2.229 1.416-3.468c1.073-1.489 1.1-2.26.083-4.363a32.936 32.936 0 0 0-4.7-7.019c-1.531-1.531-1.874-1.2-2.718-.9a15.466 15.466 0 0 0-2.485 1.332 7.508 7.508 0 0 0-2.989 3.155c-.593 1.281-1.28 3.663 2.219 9.893A55.2 55.2 0 0 0 16.9 32.074l.01.01.01.01A55.418 55.418 0 0 0 29.862 41.8c6.227 3.5 8.612 2.812 9.893 2.218a7.38 7.38 0 0 0 3.155-2.989 15.466 15.466 0 0 0 1.323-2.489c.302-.84.646-1.186-.895-2.717z",
    transform: "translate(-4.49 -4.502)",
    style: {
      fill: "#196cca"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogs);
export default __webpack_public_path__ + "static/media/callLogs.e176b3dd406ad4e9300c02566e06e0c7.svg";
export { ForwardRef as ReactComponent };